<section id="purium-sustainability-page">
    <div class="page-wrapper">
        <!-- <div class="logo">
            <img (click)="RedirectToHome()" *ngIf="!_enrollSession.mobileViewMethod()" [src]="IMAGE_URL+'/images/logos/Purium Side Logo and Transformation Company Desktop.png'" alt="" class="logo-width">
            <img (click)="RedirectToHome()" *ngIf="_enrollSession.mobileViewMethod()" [src]="IMAGE_URL+'/images/logos/logo new.png'" alt="" class="logo-width">
        </div> -->
        <app-header></app-header>
        <div class="top-banner">
            <div class="banner-content">
                <div class="heading">
                    “Many years ago, I set out to create a company that would transform both people and the planet.”
                </div>
                <div class="name">- Dave Sandoval, Purium Co-founder</div>
                <div class="para">
                    Over 20 years ago, we started this company with a clear mission: to help people transform their health while having minimal—if not positive—impact on the planet. We may have begun with just a handful of products, but every single one we’ve created since has been rooted in that original vision and unwavering commitment to our standards.
                </div>
            </div>
        </div>
        <section class="sustainability-section">
            <div class="sustainability-container">
                <div class="sustainability-img1">
                    <img class="img1" src="assets/images/purium-sustainability/pouring_protein_drink_green_into_a_glass.png" alt="Pouring Drink">
                </div>
                <div class="sustainability-text">
                    <h2 class="heading">
                        The most efficient delivery system of the highest-quality nutrition in history
                    </h2>
                    <p class="sub-heading">Shaping a Sustainable Tomorrow</p>
                    <p class="para">
                        The impact of human activity on the environment may be profound, but the future remains ours to shape. Since it was founded, Purium has worked hard to regenerate the environment, and it is our top commitment.
                    </p>
                </div>
                <!-- <div class="sustainability-img2">
                    <img class="img2" src="assets/images/purium-sustainability/wheatgrass_in_a_science_tube_clear_background.png" alt="Wheatgrass Tube">
                </div> -->
            </div>
        </section>
        <div class="section-devider1"></div>
        <div class="steps-tabs-section">
            <div class="heading-content">
                Our commitment to sustainability is woven into every aspect of our business—from the soil to your doorstep.
            </div>
            <div class="tabs">
                <button class="tab active" data-tab="tab1">Soil & Farms</button>
                <button class="tab" data-tab="tab2">Preservation & Transport</button>
                <button class="tab" data-tab="tab3">Quality Assurance & Testing</button>
                <button class="tab" data-tab="tab4">Packaging & Shelf Life</button>
            </div>
        
            <div class="tab-contents">
                <div id="tab1" class="tab-content active">
                    <div class="content-section">
                        <div class="heading">Soil & Farms</div>
                        <div class="para">
                            Organic & Regenerative Farming Practices help preserve biodiversity, enhance soil health, and reduce carbon emissions compared to conventional farming that can also contain contaminants and herbicides.
                        </div>
                        <div class="imp-points">
                           <div class="heading">Why is that important?</div>
                           <ul>
                              <li><span>Over the past 50-60 years, there has been a consistent decline in key nutrients in fruits and vegetables.</span> <span> On average, regeneratively grown vegetables had 21% more nutrients than USDA averages, according to a study by the Bionutrient Food Association.</span></li>
                              <li>Glyphosate, the active ingredient in many widely used herbicides, poses a serious threat to both human health and the environment. It has been detected in a significant portion of food and beverage products found on store shelves.</li>
                           </ul>
                        </div>
                    </div>
                    <div class="image-section">
                        <img src="assets/images/purium-sustainability/soil_farms_content.png" alt="">
                    </div>
                </div>
        
                <div id="tab2" class="tab-content">
                    <div class="content-section">
                        <div class="heading">Preservation & Transport</div>
                        <div class="para">
                            Low-temperature dehydration helps preserve the nutrients in our organic superfoods. By gently dehydrating them, we lock in maximum nutritional value, reduce waste, and minimize energy use—thanks to the minimal processing, lighter weight, and refrigeration-free storage.
                        </div>
                        <div class="imp-points">
                           <div class="heading">Why is that important?</div>
                           <ul>
                               <li>The average grocery store emits 1,900 tons of carbon dioxide annually from electricity and natural gas use, equivalent to emissions from 360 cars.</li>
                               <li>Transporting fruits and vegetables creates nearly twice as much pollution as growing them. Our delivery method is much more efficient and better for the planet than the way grocery stores get their food.</li>
                           </ul>
                        </div>
                    </div>
                    <div class="image-section">
                        <img src="assets/images/purium-sustainability/preservation_and_transport.png" alt="">
                    </div>
                </div>
        
                <div id="tab3" class="tab-content">
                    <div class="content-section">
                        <div class="heading">Quality Assurance & Testing</div>
                        <div class="para">
                            At Purium, we believe that quality is not just a standard—it’s our mission, our passion, and the very foundation of who we are. Derived from the words "Pure" and "Premium," the name Purium embodies our unwavering commitment to providing the highest-quality superfoods that nourish the body and transform lives.
                        </div>
                        <div class="imp-points">
                           <div class="heading">Why is that important?</div>
                           <ul>
                              <li>Pure Ingredients - Carefully selected for their purity, potency, and purpose from organic, non-GMO, and sustainable sources</li>
                              <li>Clean Manufacturing - Produced in certified facilities with the highest standards of cleanliness and efficiency</li>
                              <li>No Compromises - Free from artificial additives, fillers, and synthetic ingredients</li>
                              <li>Rigorous Testing - Extensive testing for potency, purity, and consistency with every batch</li>
                              <li>Plastic-Free Packaging – Thoughtfully designed to eliminate plastic waste and ensure our products never contribute to microplastic contamination in your food</li>
                           </ul>
                        </div>
                    </div>
                    <div class="image-section">
                        <img src="assets/images/purium-sustainability/quality_assurance_testing.png" alt="">
                    </div>
                </div>
        
                <div id="tab4" class="tab-content">
                    <div class="content-section">
                        <div class="heading">Packaging & Shelf Life</div>
                        <div class="para">
                            Our terra pouches meet the ASTM D6400 standards which are:
                        </div>
                        <div class="para">
                            <span>Biodegradability: </span>
                            The ability of plastic to break down into natural elements in a composting environment within a specific timeframe, typically 180 days or less.
                        </div>
                        <div class="para">
                            <span>Compostability: </span>
                            The standard establishes criteria for determining if a plastic product will degrade and disintegrate into non-toxic, environmentally safe elements in a composting system.
                        </div>
                        <div class="para">
                            <span>Disintegration: </span>
                            The product must break down completely within a certain period, typically within 90 days in a composting environment.
                        </div>
                        <div class="para">
                            <span>Toxicity Testing: </span>
                            The material must be non-toxic to plants, microorganisms, and animals in the composting environment.
                        </div>
                        <div class="para">
                            <span>Labeling: </span>
                            Plastics that meet the ASTM D6400 standard can be labeled as "compostable" and can carry the appropriate certification mark.
                        </div>
                        <div class="imp-points">
                           <div class="heading">Why is that important?</div>
                           <ul>
                              <li>The dietary supplement industry significantly contributes to plastic waste, with approximately 1.8 billion plastic supplement bottles sold annually in the U.S. alone.</li>
                              <li>Our terra pouches have saved over 300,000 (and counting) pounds of plastic from entering oceans and landfills</li>
                           </ul>
                        </div>
                    </div>
                    <div class="image-section">
                        <img src="assets/images/purium-sustainability/packaging_and_shelf_life.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="solve-glyphosate-crisis">
            <div class="first-section">
                <div class="image-section" *ngIf="!_enrollSession.mobileViewMethod()">
                    <img src="assets/images/purium-sustainability/solve-glyphosate-crisis.png" alt="">
                </div>
                <div class="content-section">
                    <div class="heading">Solving The Glyphosate Crisis</div>
                    <div class="para">
                        Our gut microbiomes and gut linings are being compromised by a toxic, cancer-inducing herbicide known as glyphosate. This prevalent weed killer, found in 75% of our food and 90% of beer and wine, primarily affects crops with genetically modified seeds (GMOs). It's also used as a desiccant on other crops like wheat, oats, and barley. The plants absorb these chemicals into their cells, making it ineffective to remove them by washing or cooking.
                    </div>
                    <div class="para">
                        An alarming 95% of Americans carry this chemical in their bodies. In 2017, the State of California confirmed that glyphosate "causes cancer and birth defects," and subsequently added it to the Proposition 65 list.
                    </div>
                    <div class="para">
                        Our gut, often referred to as our "second brain," plays a crucial role in nutrient absorption, hormone production, and immune response.
                    </div>
                </div>
                <div class="image-section" *ngIf="_enrollSession.mobileViewMethod()">
                    <img src="assets/images/purium-sustainability/solve-glyphosate-crisis.png" alt="">
                </div>
            </div>
            <div class="second-section">
                <div class="image-section">
                    <img src="assets/images/purium-sustainability/the-solution.png" alt="">
                </div>
                <div class="content-section">
                    <div class="heading">The Solution</div>
                    <div class="mt-4">
                        <img src="../../../assets/images/Transformation/stars.svg" alt="">
                    </div>
                    <div class="sub-heading mt-2 mb-4">Biome Medic - 300+ 5-Star Review</div>
                    <div class="para">
                        Biome Medic offers a proven solution. It has demonstrated the ability to remove glyphosate and promote a healthy gut, both safely and effectively.
                    </div>
                    <div class="para">
                        Proven Results* in just 6 weeks:
                    </div>
                    <div class="points">
                        <ul>
                           <li>74% Reduction in Glyphosate</li>
                           <li>75% Reduction in C-Reactive Protein</li>
                           <li>35% Increase in Intestinal Integrity</li> 
                        </ul>
                    </div>
                    <div class="para">
                        Discover the hidden dangers of glyphosate and how Biome Medic can help remove toxins while supporting a healthy gut. Learn more in Dave Sandoval’s book, The Toxin That Came to Dinner. Plus, take a look at these resources below:
                    </div>
                    <div class="biome-links">
                        <ul>
                           <li><a href="http://www.puriumcorporate.com/purium1/php_uploads/Detox_Certification_.pdf" target="_blank">Detox Certification Press Release</a></li>
                           <li><a href="http://www.puriumcorporate.com/purium1/php_uploads/email/Biome-Medic-Final-Report-for-Health-Professionals-November-2017.pdf" target="_blank">Full Trial report</a></li>
                           <li><a href="https://media-purium-bucket.s3.amazonaws.com/BiomeMedicResearchResults-PressRelease.pdf" target="_blank">Biome Medic Press Release</a></li>
                           <li><a href="https://cdn.ishoppurium.store/Product_Fact_Sheet_BiomeMedic.pdf" target="_blank">Biome Medic Fact Sheet</a></li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="reviews-section">
             <div class="heading">
               <div>Get a FREE digital copy of Dave Sandoval’s “The Toxin That Came to Dinner”</div> 
                <div>when you purchase a Lifestyle Subscription, ULT or Biome Medic</div> 
            </div>
             <!-- <div class="mt-4">
                 <img src="../../../assets/images/Transformation/stars.svg" alt="">
             </div> -->
             <div class="carousel-container">
                <ngx-slick-carousel 
                #slickModal="slick-carousel" 
                [config]="slideConfig" 
                class="carousel customCarousel">
                <div ngxSlickItem *ngFor="let slide of purium_reviews" class="slide">
                    <div class="testimonial-card">
                          <div class="review-heading">
                            <sup>
                                <img src="../../../assets/images/Transformation/left-quote.svg" alt="">
                            </sup>
                            <span>{{slide.review_heading}}</span>
                            <sup>
                                <img src="../../../assets/images/Transformation/right-quote.svg" alt="">
                            </sup>
                          </div>
                          <div class="review-text">
                             {{slide.review_text}}
                          </div>
                          <div class="reviewer-name">
                            <span>-</span> {{slide.name}}
                         </div>
                         <div class="navigation-arrows">
                            <button (click)="slickModal.slickPrev()" class="arrow-btn">←</button>
                            <button (click)="slickModal.slickNext()" class="arrow-btn">→</button>
                        </div>
                    </div>
                </div>
               </ngx-slick-carousel>
             </div>
        </div>
        <div class="own-review-section">
             <div class="carousel-container">
                <ngx-slick-carousel 
                #slickModal1="slick-carousel" 
                [config]="slideConfig" 
                class="carousel customCarousel">
                <div ngxSlickItem *ngFor="let slide of own_reviews" class="slide">
                    <div class="testimonial-card">
                        <div class="review-text">{{slide.review}}</div>
                         <div class="navigation-arrows">
                            <button (click)="slickModal1.slickPrev()" class="arrow-btn">←</button>
                            <button (click)="slickModal1.slickNext()" class="arrow-btn">→</button>
                        </div>
                    </div>
                </div>
               </ngx-slick-carousel>
             </div>
             <div class="power-shake-img">
                <img src="assets/images/purium-sustainability/power-shake-img.png" alt="">
             </div>
        </div>
        <div class="video-explaination-section">
            <div class="heading"><span class="first-text">Watch Co-founder Dave Sandoval explain how</span><span class="in-between-text"> Purium has developed <br> the most efficient food delivery system</span> <span class="last-text"> on the planet.</span></div>
            <div class="iframevideo1">
                <!-- <iframe class="iframeClass"
                src="https://player.vimeo.com/video/700602743" frameborder="0"
                data-resize-to-parent="true" allow="clipboard-write"></iframe> -->
                <video class="iframeClass" src="https://cdn.ishoppurium.com/why_purium_went_eco_friendly.mp4"  
                 muted playsinline preload="auto" controls  onloadeddata="this.currentTime = 4;"></video>
            </div>
            <div class="paragraphs">
               <div class="para1">The world needs our help to reduce carbon emissions. While some ways might be highly impractical for your daily life, adopting the Purium lifestyle is something you can easily do today! If you switch two of your meals with Purium shakes, you can reduce your carbon footprint in half. Need some ideas? Here’s some of our top picks that will keep you and mother nature healthy.</div>
               <div class="para2">That’s why we made it our priority to reduce our plastic waste by transitioning into biodegradable Terra Pouch packaging, eliminating plastic scoops and converting to stainless steel accessories.</div>
            </div>
            <div class="testimonial-card">
                <div class="iframevideo2">
                    <video class="iframeClass1" src="https://cdn.ishoppurium.com/purium_farm_to_family.mp4"
                    muted playsinline preload="auto" controls  onloadeddata="this.currentTime = 7;"></video>
                </div>
                <div class="iframevideo2">
                  <video class="iframeClass2" src="https://cdn.ishoppurium.com/amy_venner_red_carpet_interview_at_the_pfpa_gala.mp4"
                  muted playsinline preload="auto" controls  onloadeddata="this.currentTime = 6;"></video>
                </div>
            </div>
            <!-- <div class="">
              <ngx-slick-carousel 
                #slickModal2="slick-carousel" 
                [config]="slideConfig" 
                class="carousel customCarousel">
                <div class="navigation-arrows" *ngIf="!_enrollSession.mobileViewMethod()">
                    <button (click)="slickModal2.slickPrev()" class="arrow-btn">←</button>
                </div>
                <div class="testimonial-card">
                    <div class="iframevideo2">
                        <video class="iframeClass1" src="https://cdn.ishoppurium.com/purium_farm_to_family.mp4"
                        muted playsinline preload="auto" controls  onloadeddata="this.currentTime = 7;"></video>
                    </div>
                    <div class="iframevideo2">
                      <video class="iframeClass2" src="https://cdn.ishoppurium.com/amy_venner_red_carpet_interview_at_the_pfpa_gala.mp4"
                      muted playsinline preload="auto" controls  onloadeddata="this.currentTime = 6;"></video>
                    </div>
                </div>
                <div class="navigation-arrows" *ngIf="!_enrollSession.mobileViewMethod()">
                    <button (click)="slickModal2.slickNext()" class="arrow-btn">→</button>
                </div>
             </ngx-slick-carousel>
            </div> -->
            <!-- <script src="https://player.vimeo.com/api/player.js"></script>
            <script src="https://v0.wordpress.com/js/next/videopress-iframe.js?m=1674852142"></script> -->
        </div>
        <div class="save-environment-section">
            <!-- <img src="assets/images/purium-sustainability/environment-image.png" alt="" class="background-img"> -->
            <div class="content">
                <div class="heading">We’ve saved over 300,000 Ibs of plastic from environmental contamination</div>
                <div class="sub-heading"><div>Thanks to Purium’s compostable packaging known as the “Terra Pouch,”</div> 
                   <div>we have nearly eliminated our one-use plastic tubs and bottles!</div></div>
                <div class="image-container">
                   <img src="assets/images/purium-sustainability/environment-images.png" alt=""> 
                </div>
            </div>
        </div>
        <div class="track-progress-section">
            <!-- <img src="assets/images/purium-sustainability/progress-track-image.png" alt=""> -->
             <div class="main-heading"><span class="text1">Track Our Sustainable Packaging</span><span class="text2"> progress</span></div>

             <div class="timeline" *ngIf="!_enrollSession.mobileViewMethod()">
                <div class="horizontal-line">
                  <div class="timeline-item">
                    <div class="content top">
                        <div class="year">2016</div>
                        <div class="text">Eliminate plastic scoops from powder products.</div>
                        <div class="number">1</div>
                    </div>
                    <div class="dot">
                        <div class="vertical-line-top"></div>
                    </div>
                   </div> 
                   <div class="timeline-item">
                    <div class="dot">
                        <div class="vertical-line-bottom"></div>
                    </div>
                    <div class="content bottom">
                        <div class="number">2</div>
                        <div class="text">Transition most popular products from plastic to compostable terra pouches.</div>
                        <div class="year">2018</div>
                    </div>
                    </div>
                    <div class="timeline-item">
                        <div class="content top">
                            <div class="year">2021</div>
                            <div class="text">Offer eco-friendly storage and measuring spoons.</div>
                            <div class="number">3</div>
                        </div>
                        <div class="dot">
                            <div class="vertical-line-top"></div>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="dot">
                            <div class="vertical-line-bottom"></div>
                        </div>
                        <div class="content bottom">
                            <div class="number">4</div>
                            <div class="text">Transition terra pouches to resealable zipper terra pouches.</div>
                            <div class="year">2021</div>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="content top">
                            <div class="year">2021</div>
                            <div class="text">Replace our plastic shaker bottle with stainless steel in featured packs.</div>
                            <div class="number">5</div>
                        </div>
                        <div class="dot">
                            <div class="vertical-line-top"></div>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="dot">
                            <div class="vertical-line-bottom"></div>
                        </div>
                        <div class="content bottom">
                            <div class="number">6</div>
                            <div class="text">Eliminate over 95% of plastic packaging.</div>
                            <div class="year">2021</div>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="content top">
                            <div class="year">2023</div>
                            <div class="text">Decrease the amount of paper literature waste and impact by utilizing QR codes, and partnering with vegan printing services.</div>
                            <div class="number">7</div>
                        </div>
                        <div class="dot">
                            <div class="vertical-line-top"></div>
                        </div>
                    </div>
                    <div class="timeline-item">
                        <div class="dot">
                            <div class="vertical-line-bottom"></div>
                        </div>
                        <div class="content bottom">
                            <div class="number">8</div>
                            <div class="text">Eliminate labels by printing directly on the package.</div>
                            <div class="year">2024</div>
                        </div>
                    </div>
                </div>
             </div>

             <div class="timeline" *ngIf="_enrollSession.mobileViewMethod()">
                <div class="horizontal-line"></div>
              
                <div class="timeline-item">
                  <div class="content">
                      <div class="number">1</div>
                    <div class="text">Eliminate plastic scoops from powder products.</div>
                    <div class="year">2016</div>
                  </div>
                  <div class="dot"><div class="vertical-line"></div></div>
                </div>
              
                <div class="timeline-item">
                    <div class="content">
                        <div class="number">2</div>
                        <div class="text">Transition most popular products from plastic to compostable terra pouche</div>
                        <div class="year">2018</div>
                    </div>
                    <div class="dot"><div class="vertical-line"></div></div>
                </div>
              
                <div class="timeline-item">
                  <div class="content">
                      <div class="number">3</div>
                    <div class="text">Offer eco-friendly storage and measuring spoons.</div>
                    <div class="year">2021</div>
                  </div>
                  <div class="dot"><div class="vertical-line"></div></div>
                </div>
              
                <div class="timeline-item">
                    <div class="content">
                        <div class="number">4</div>
                        <div class="text">Transition terra pouches to resealable zipper terra pouches.</div>
                        <div class="year">2021</div>
                    </div>
                    <div class="dot"><div class="vertical-line"></div></div>
                </div>

                <div class="timeline-item">
                    <div class="content">
                        <div class="number">5</div>
                        <div class="text">Replace our plastic shaker bottle with stainless steel in featured packs.</div>
                        <div class="year">2021</div>
                    </div>
                    <div class="dot"><div class="vertical-line"></div></div>
                </div>
                <div class="timeline-item">
                    <div class="content">
                        <div class="number">6</div>
                        <div class="text">Eliminate over 95% of plastic packaging.</div>
                        <div class="year">2021</div>
                    </div>
                    <div class="dot"><div class="vertical-line"></div></div>
                  </div>

                  <div class="timeline-item">
                    <div class="content">
                        <div class="number">7</div>
                        <div class="text">Decrease the amount of paper literature waste and impact by utilizing QR codes, and partnering with vegan printing services.</div>
                        <div class="year">2021</div>
                    </div>
                    <div class="dot"><div class="vertical-line"></div></div>
                  </div>

                  <div class="timeline-item">
                      <div class="content">
                          <div class="number">8</div>
                          <div class="text">Eliminate labels by printing directly on the package.</div>
                          <div class="year">2024</div>
                        </div>
                        <div class="dot"><div class="vertical-line"></div></div>
                  </div>
              </div>
        </div>
        <div class="purium-mission-section">
            <div class="heading">Join Purium’s Mission for a Greener Future</div>
            <div class="main-section">
                <img src="assets/images/purium-sustainability/group-people.png" alt="">
                <div class="center">
                    <div class="quote">"We cannot heal the world if we can't take care of our neighbor."</div>
                    <div class="name">- Dave Sandoval</div>
                    <div class="para">
                        By uplifting your own community, you can create larger environmental shifts. Learn how Purium’s Business Opportunity is a holistic model for ultimate transformation.
                    </div>
                </div>
                <img src="assets/images/purium-sustainability/amy.png" alt="">
            </div>
            <!-- <div class="learn-more-btn">
                <a  [routerLink]="['/']" class="main-btn ult-btn"><div>LEARN MORE</div>
                    <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="70" alt="">
                </a>
            </div> -->
        </div>
        <div class="want-to-do-your-part-section">
            <div class="heading">be the change-one meal at a time</div>
            <div class="para">Your choices matter. Lower your carbon FOODprint with the Purium Lifestyle Subscription—a simple, sustainable way to nourish your body and the planet. Take your impact even further by sharing this mission as a Purium Brand Partner and inspiring others to join the movement. Are you ready to make a difference?</div>
            <div class="container smallScreenPadding subscribe-btn">
                <a  [routerLink]="['/Ultlifestyle']" class="main-btn ult-btn"><div>subscribe today</div>
                    <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
                </a>
            </div>
            <div class="container smallScreenPadding brand-partner-btn">
                <a  href="https://puriumenrollment.com/Home" class="main-btn ult-btn"  target="_blank"><div>become a brand partner</div>
                    <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
                </a>
            </div>
            <!-- <img src="assets/images/purium-sustainability/Want-to-do-your-part.png" alt=""> -->
        </div>
        <div class="lifestyle-transformation-guide-section">
            <div class="left-section">
                <div class="heading"><span class="text1">Ultimate</span> <span class="text2"> Lifestyle</span><div class="text3">Transformation</div></div>
                <div class="para1">
                    It takes 90 days to create a habit and Purium has the solution. Wake up rejuvenated, feeling energetic all day, and free from bloat and brain fog – without restricting your lifestyle. This program focuses on nourishing your body, not depriving it. Fuel your body with the ULT's nutrient-rich superfoods. Designed to fit seamlessly into any lifestyle, the ULT makes better health easy and accessible.
                </div>
                <div class="para2">
                    Not only will you transform your body, but you’ll also dramatically reduce your carbon footprint by making a sustainable, eco-friendly choice. It's the perfect way to nourish yourself and the planet.
                </div>
                <div class="container smallScreenPadding start-today-btn" *ngIf="!_enrollSession.mobileViewMethod()">
                    <a  [routerLink]="['/Ultlifestyle']" class="main-btn ult-btn"><div>start today</div>
                        <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="70" alt="">
                    </a>
                </div>
            </div>
            <div class="right-section">
                <img src="assets/images/purium-sustainability/Render_Mockup_4000_3000_2025-02-21 1.png" alt="">
            </div>
            <div class="container smallScreenPadding start-today-btn" *ngIf="_enrollSession.mobileViewMethod()">
                <a  [routerLink]="['/Ultlifestyle']" class="main-btn ult-btn"><div>start today</div>
                    <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="70" alt="">
                </a>
            </div>
        </div>
        <div class="section-devider2"></div>
        <div class="purium-add-ons-section">
            <div class="heading"><span class="text1">Purium</span> <span class="text2">  Add-ons</span></div>

            <div class="carousel-container">
                <div *ngIf="!_enrollSession.mobileViewMethod()">
                    <button (click)="slickModal3.slickPrev()" class="arrow-btn">←</button>
                </div>
                <ngx-slick-carousel #slickModal3="slick-carousel"  [config]="slideConfig" class="carousel customCarousel"
                (afterChange)="getCurrentSlide($event)">
                  <div ngxSlickItem *ngFor="let slide of addOnProducts" class="slide">
                    <div class="testimonial-card">
                        <div class="product-img">
                            <img [src]="slide.product_image" alt="unable to load please try again">
                        </div>
                        <div class="product-desc">
                            <div class="heading">{{slide.product_desc.heading}}</div>
                            <div class="para">{{slide.product_desc.para}}</div>
                            <div class="container smallScreenPadding shop-now-btn">
                                <a  [routerLink]="['/AllProducts/'+slide.product_desc.itemCode]" class="main-btn ult-btn"><div>shop now</div>
                                    <img class="" [src]="IMAGE_URL+'/icons/YellowLineArrow.png'" width="50" alt="">
                                </a>
                            </div>
                        </div>
                        <div class="navigation-arrows" *ngIf="_enrollSession.mobileViewMethod()">
                            <button (click)="slickModal3.slickPrev()" class="arrow-btn">←</button>
                            <button (click)="slickModal3.slickNext()" class="arrow-btn">→</button>
                        </div>
                    </div>
                  </div>
                </ngx-slick-carousel>
                <div *ngIf="!_enrollSession.mobileViewMethod()">
                    <button (click)="slickModal3.slickNext()" class="arrow-btn">→</button>
                </div>
            </div>
            <!-- <div class="products-add-on">
                <img src="assets/images/purium-sustainability/add-on-product1.png" alt="" [ngClass]="{'border-highlight': currentSlideIndex === 1}">
                <img src="assets/images/purium-sustainability/add-on-product2.png" alt="" [ngClass]="{'border-highlight': currentSlideIndex === 0}">
                <img src="assets/images/purium-sustainability/add-on-product3.png" alt="" [ngClass]="{'border-highlight': currentSlideIndex === 2}">
            </div> -->
        </div>
        <div class="plant-based-solution-section">
            <div class="heading1">good for you, good for our planet</div>
            <div class="heading2">
                <span class="text1">Plant-based is the</span>
                <span class="text2"> solution</span>
                <img src="assets/images/purium-sustainability/instagram-1.png" alt="">
            </div>
            <div class="images-gallery">
                <img src="assets/images/purium-sustainability/gallery-img1.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img2.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img3.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img4.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img5.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img6.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img7.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img8.png" alt="">
                <img src="assets/images/purium-sustainability/gallery-img9.png" alt="">
            </div>
        </div>
        <div>
            <img [src]="IMAGE_URL+'/images/Transformation/make-Curve-1.png'" alt="">
        </div>
        <app-footercomponent></app-footercomponent>
    </div>
</section>